import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";

const TITLE = "Calculatrice de temps d'apprentissage de l'anglais - Estimez votre parcours";
const DESCRIPTION =
  "Calculatrice de temps d'apprentissage de l'anglais - Estimez votre parcours. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "english learning time calculator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/english-learning-time-calculator/";

const EnglishLearningTimeCalculator = () => {
  const [lessonsPerWeek, setLessonsPerWeek] = useState("");
  const [lessonTime, setLessonTime] = useState("");
  const [timeUnit, setTimeUnit] = useState("minutes");
  const [timeFormat, setTimeFormat] = useState("weeks");
  const [totalWeeklyHours, setTotalWeeklyHours] = useState("");
  const [timeToLevels, setTimeToLevels] = useState({});
  const [error, setError] = useState("");

  const LEVELS = {
    A1: 100,
    A2: 100,
    B1: 200,
    B2: 200,
    C1: 200,
    C2: 200,
  };

  const calculateTotalHours = (lessons, time, unit) => {
    const timeInHours = unit === "minutes" ? parseFloat(time) / 60 : parseFloat(time);
    return parseFloat(lessons) * timeInHours;
  };

  const calculateTimeForLevels = (weeklyHours) => {
    let result = {};
    let accumulated = 0;
    Object.entries(LEVELS).forEach(([level, hours]) => {
      accumulated += hours;
      result[level] = formatTime(accumulated / weeklyHours);
    });
    return result;
  };

  const formatTime = (weeks) => {
    switch (timeFormat) {
      case "days": return (weeks * 7).toFixed(1) + " jours";
      case "months": return (weeks / 4).toFixed(1) + " mois";
      case "years": return (weeks / 52).toFixed(1) + " ans";
      default: return weeks.toFixed(1) + " semaines";
    }
  };

  const handleCalculate = () => {
    try {
      if (!lessonsPerWeek || !lessonTime) {
        throw new Error("Veuillez entrer le nombre de cours par semaine et la dure moyenne d'un cours.");
      }
      const lessonTimeValue = lessonTime.includes(":")
        ? parseFloat(lessonTime.split(":")[0]) + parseFloat(lessonTime.split(":")[1]) / 60
        : parseFloat(lessonTime);
      const totalHours = calculateTotalHours(parseFloat(lessonsPerWeek), lessonTimeValue, timeUnit);
      setTotalWeeklyHours(totalHours.toFixed(2) + " heures/semaine");
      setTimeToLevels(calculateTimeForLevels(totalHours));
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice estime le temps ncessaire pour atteindre chaque niveau du cadre europen
                  commun de rfrence (CECRL) en anglais, selon votre rythme d'tude hebdomadaire. Le calcul se
                  base sur les donnes de{" "}
                  <a href="https://support.cambridgeenglish.org/hc/en-gb/articles/202838506-Guided-learning-hours" rel="nofollow">
                    Cambridge English
                  </a>
                  , qui fournissent une estimation du nombre d'heures guides ncessaires pour chaque niveau.
                </p>
                <p>
                  Notez que ces chiffres sont approximatifs : le temps rel dpend de votre langue maternelle,
                  de l'intensit de votre tude, de votre ge, de l'exposition  la langue en dehors des cours
                  et de la qualit de l'enseignement.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Calculatrice de temps d'apprentissage de l'anglais</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b><label className="form-label ms-2">Cours par semaine</label></b>
                    <input
                      type="number"
                      placeholder="Ex : 5"
                      value={lessonsPerWeek}
                      onChange={(e) => setLessonsPerWeek(e.target.value)}
                      className="form-control"
                      style={{ width: "50%" }}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b><label className="form-label ms-2">Dure du cours</label></b>
                    <input
                      type="text"
                      placeholder="Ex : 60"
                      value={lessonTime}
                      onChange={(e) => setLessonTime(e.target.value)}
                      className="form-control"
                      style={{ width: "40%" }}
                    />
                    <select
                      value={timeUnit}
                      onChange={(e) => setTimeUnit(e.target.value)}
                      className="form-select ms-2"
                      style={{ width: "25%" }}
                    >
                      <option value="minutes">Minutes</option>
                      <option value="hours">Heures</option>
                    </select>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b><label className="form-label ms-2">Format des rsultats</label></b>
                    <select
                      value={timeFormat}
                      onChange={(e) => setTimeFormat(e.target.value)}
                      className="form-select ms-2"
                      style={{ width: "25%" }}
                    >
                      <option value="days">Jours</option>
                      <option value="weeks">Semaines</option>
                      <option value="months">Mois</option>
                      <option value="years">Ans</option>
                    </select>
                  </div>
                  <br />
                  <button className="btn btn-success" style={{ fontSize: "20px" }} onClick={handleCalculate}>
                    Calculer
                  </button>
                  <br />
                  {error && <p style={{ color: "red" }}>{error}</p>}
                  <br />
                  {totalWeeklyHours && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <hr />
                      <p>Rsultats :</p>
                      <p>Total heures hebdomadaires : <b>{totalWeeklyHours}</b></p>
                      <p><b>{timeToLevels.A1}</b>  du niveau A1  A2</p>
                      <p><b>{timeToLevels.A2}</b>  du niveau A2  B1</p>
                      <p><b>{timeToLevels.B1}</b>  du niveau B1  B2</p>
                      <p><b>{timeToLevels.B2}</b>  du niveau B2  C1</p>
                      <p><b>{timeToLevels.C1}</b>  du niveau C1  C2</p>
                      <p><b>{timeToLevels.C2}</b>  temps total de A1  C2</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Quels sont les niveaux de la langue anglaise ?</h2>
              </div>
              <div className="info-section-body">
                <p>
                  Les niveaux d'anglais sont dfinis selon le Cadre Europen Commun de Rfrence pour les Langues (CECRL).
                  Ce cadre comprend 6 niveaux :
                </p>
                <ul>
                  <li><strong>A1 (Dbutant) :</strong> Vous comprenez et utilisez des expressions quotidiennes trs basiques.</li>
                  <li><strong>A2 (lmentaire) :</strong> Vous pouvez changer des informations simples et directes.</li>
                  <li><strong>B1 (Intermdiaire) :</strong> Vous pouvez grer la plupart des situations rencontres en voyage.</li>
                  <li><strong>B2 (Intermdiaire suprieur) :</strong> Vous interagissez aisment avec des anglophones natifs.</li>
                  <li><strong>C1 (Avanc) :</strong> Vous utilisez la langue avec souplesse dans un contexte social et professionnel.</li>
                  <li><strong>C2 (Matrise) :</strong> Vous comprenez et utilisez l'anglais avec une grande prcision et aisance.</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Pourquoi connatre son niveau d'anglais ?</h2>
              </div>
              <div className="info-section-body">
                <p>Connatre votre niveau actuel vous permet de :</p>
                <ul>
                  <li><strong>Suivre votre progression :</strong> mesurer vos avances de niveau en niveau.</li>
                  <li><strong>Fixer des objectifs ralistes :</strong> adapter vos buts  votre niveau actuel.</li>
                  <li><strong>Choisir les bons supports :</strong> livres, cours et applications adapts  votre niveau.</li>
                  <li><strong>Planifier votre apprentissage :</strong> estimer le temps ncessaire pour atteindre un niveau cible.</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Combien d'heures faut-il pour apprendre l'anglais ?</h2>
              </div>
              <div className="info-section-body">
                <p>Selon les donnes de Cambridge English, voici le nombre cumul d'heures guides ncessaires pour atteindre chaque niveau :</p>
                <table className="table bmi-table">
                  <thead>
                    <tr>
                      <th className="bmi-header">Niveau</th>
                      <th className="bmi-header">Heures cumules</th>
                      <th className="bmi-header">Heures pour ce niveau</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>A1 ? A2</td><td>100 h</td><td>100 h</td></tr>
                    <tr><td>A2 ? B1</td><td>200 h</td><td>100 h</td></tr>
                    <tr><td>B1 ? B2</td><td>400 h</td><td>200 h</td></tr>
                    <tr><td>B2 ? C1</td><td>600 h</td><td>200 h</td></tr>
                    <tr><td>C1 ? C2</td><td>800 h</td><td>200 h</td></tr>
                    <tr><td><strong>Total A1 ? C2</strong></td><td><strong>1000 h</strong></td><td></td></tr>
                  </tbody>
                </table>
                <p>Ces chiffres varient selon votre langue maternelle, la qualit de l'enseignement et votre engagement personnel.</p>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Conseils pour apprendre l'anglais plus vite</h2>
              </div>
              <div className="info-section-body">
                <ul>
                  <li><strong>Pratiquez quotidiennement :</strong> mme 15  20 minutes par jour sont plus efficaces qu'une longue session hebdomadaire.</li>
                  <li><strong>Consommez du contenu en anglais :</strong> films, sries, podcasts et articles vous exposent  la langue naturellement.</li>
                  <li><strong>Parlez avec des natifs :</strong> les changes linguistiques ou les applications de conversation acclrent la progression.</li>
                  <li><strong>Apprenez le vocabulaire en contexte :</strong> plutt que de mmoriser des listes, dcouvrez les mots dans des phrases.</li>
                  <li><strong>Fixez-vous des objectifs clairs :</strong> un objectif prcis (passer le TOEFL, dcrocher un poste) vous maintient motiv.</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Comment utiliser cette calculatrice ?</h2>
              </div>
              <div className="info-section-body">
                <ol>
                  <li>Entrez le nombre de cours que vous suivez par semaine.</li>
                  <li>Indiquez la dure moyenne d'un cours (en minutes ou en heures).</li>
                  <li>Choisissez le format d'affichage des rsultats (jours, semaines, mois ou ans).</li>
                  <li>Cliquez sur  Calculer  pour voir le temps estim pour chaque niveau.</li>
                </ol>
                <p>
                  La calculatrice affiche le temps total cumul depuis le niveau A1 pour atteindre chaque
                  palier jusqu'au C2 (matrise complte).
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default EnglishLearningTimeCalculator;
